
import React, { createContext, useContext, useState } from 'react';
import { BookSession } from '@/utils/sessionStore';

interface SessionContextType {
  activeSession: BookSession | null;
  setActiveSession: (session: BookSession | null) => void;
}

const SessionContext = createContext<SessionContextType>({
  activeSession: null,
  setActiveSession: () => {}
});

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeSession, setActiveSession] = useState<BookSession | null>(null);

  return (
    <SessionContext.Provider value={{ activeSession, setActiveSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
